import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import LeftSideMenu from '../left-side-bar/LeftSideMenu';
import { usePermission } from '../../../helpers/common';

const SideBar = ({ show, match }) => {
    const allow = usePermission();
    const isAllowMap = allow("map", "view");
    const isShow = isAllowMap ? show : false;

    return (<div className={isShow ? "show" : "hide"}>
        <Route
            path={match.path}
            component={LeftSideMenu}
        />
    </div>);
}

const mapStateToProps = state => ({
    show: state.user.leftSideMenu.show
});

export default connect(mapStateToProps)(SideBar);